import { Component } from '@angular/core';
import { MenuController, NavController, Events } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { SigninComponent } from '../authentication/components/signin/signin.component';
import { AuthenticationService } from '../../../../../UI/src/app/shared/authentication/authentication.service';
import { TranslationLoaderService } from '../../../../../UI/src/app/shared/translation/translation-loader.service';
import { AddResumeComponent } from '../authentication/components/add-resume/add-resume.component';
import { JobSearchComponent } from '../job-search/job-search.component';
import { Storage } from '../../../../../UI/src/app/shared/constants';
import { BrandingService } from '../../../../../UI/src/app/shared/branding/branding.service';
import { JobSearchLocationComponent } from '../job-search/components/job-location-modal/job-location-modal.component';
import { JobSearchService } from '../../../../../UI/src/app/shared/job-search/job-search.service';

@Component({
  selector: 'component-home',
  templateUrl: 'home.component.html'
})
export class HomeComponent {
  loginPage: any = SigninComponent;
  jobSearchComponent: any = JobSearchComponent;
  searchText: String = "";
  locationText: String = "";
  private accessCode;
  private errorcode;
  public goToThirdStep: boolean = true;
  public notLoggedIn = true;
  public enabledLocales: any;
  public selectedLocale = '';

  constructor(
    public navCtrl: NavController,
    private authenticationservice: AuthenticationService,
    public events: Events,
    public modalCtrl: ModalController,
    public menu: MenuController,
    private translationLoader: TranslationLoaderService,
    private brandingService: BrandingService,
    public jobSearchService: JobSearchService
  ) {
    this.checkAndRedirectToHomeURL();
    this.accessCode = location.href.split('?code=')[1];
    this.errorcode = location.href.split('?error=')[1];
    if(this.accessCode || this.errorcode)
      this.navCtrl.push(AddResumeComponent, this.goToThirdStep);
    this.notLoggedIn = !this.authenticationservice.isUserLoggedin();
    if (this.authenticationservice.isUserLoggedin()) {
      this.events.publish('showSiteMapNodes', true);
    }
    else {
      this.events.publish('showSiteMapNodesPublic', true);
    }
    this.getEnabledLocales();
    if (window.localStorage.getItem(Storage.CULTURE)) {
      this.selectedLocale = window.localStorage.getItem(Storage.CULTURE)
    }
  }

 

  setHomePageBackground() {
    const backgroundImageUrl = this.brandingService.getMobileBgImgUrl();
    const bgs = document.getElementsByClassName('page-background');
    if (bgs) {
      Object.keys(bgs).forEach(function (key) {
        bgs[key].style.backgroundImage = 'url(' + backgroundImageUrl + ')';
      });
    }
  }

  onSignin() {
    this.navCtrl.push(this.loginPage);
  }

  loadTranslations() {
    window.localStorage.setItem(Storage.CULTURE, this.selectedLocale);
    this.translationLoader.checkCultureChange(this.selectedLocale);
    window.location.reload();
  }

  getEnabledLocales() {
    this.authenticationservice.getEnabledLocales().subscribe(
      (response) => {
        this.enabledLocales = response;
      }, (error) => {
      }
    );
  }

  searchJobs() {
    this.navCtrl.push(this.jobSearchComponent, {
      searchText: this.searchText,
      loc: this.locationText
    });
    this.searchText = "";
   
  }

  removeSearchText(){
    this.searchText = "";
  }

 

  getlogo() {
    return this.brandingService.getMobileLogoUrl();
  }

  getLogoRedirectionURL() {
    if(window.localStorage.getItem(Storage.LOGO_REDIRECT_URL)) {
      window.location.href = window.localStorage.getItem(Storage.LOGO_REDIRECT_URL);
      event.preventDefault();
    }
  }

  checkAndRedirectToHomeURL() {
    let URL = this.navCtrl.getActive();
    //navigate to Home URL automatically when the Home page is being loaded based on Home URL setting in Theme.
    let careerHomeUrl = window.localStorage.getItem(Storage.HOME_REDIRECT_URL);
    if((careerHomeUrl && !URL) ||
       (careerHomeUrl && (location.href.split('#')[1] == undefined || location.href.split('/').pop() == 'home'))) {
      window.location.href = careerHomeUrl;
      event.preventDefault();
    }
  }

 
}



// WEBPACK FOOTER //
// ./src/app/modules/home/home.component.ts